import { styled } from "../../../../styled-system/jsx";

export const PageContainer = styled("div", {
  base: {
    display: "flex",
    gap: "medium",
    flexDirection: "column",
    minHeight: "pageHeight",
    padding: "1rem",
    backgroundColor: "appBackground",
  },
  variants: {
    withBreadcrumb: {
      true: {
        minHeight: "pageHeight.withBreadcrumb",
      },
    },
  },
});
